import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ClientInvoiceEvaluatorPaymentItem from '../../../../Domain/ClientInvoiceEvaluatorPaymentItem';
import ClientInvoiceEvaluatorPaymentSearchParams from './ClientInvoiceEvaluatorPaymentSearchParams';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ErrorMessage from '../../../../Elements/ErrorMessage';

export default class EvaluatorPaymentsSubTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new ClientInvoiceEvaluatorPaymentSearchParams(),
    };
    this.state.searchItem.ClientInvoiceId = this.props.clientInvoiceId;

    this.startSearch = this.startSearch.bind(this);
    this.serviceFunction = this.serviceFunction.bind(this);
  }

  startSearch(searchItem) {
    // "Clear All Filters" hands back a fresh search item without the invoice id. The list re-adds it
    // for its own fetch, but the Excel export sends this item as it is.
    searchItem.ClientInvoiceId = this.props.clientInvoiceId;
    this.setState({ searchItem });
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const tempSearchItem = { ...searchItem };
    tempSearchItem.ClientInvoiceId = this.props.clientInvoiceId;
    return EvaluatorPaymentService.GetEvaluatorPaymentsByClientInvoice(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      tempSearchItem,
      clearCache
    );
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => {
                EvaluatorPaymentService.ExportToExcel(this.state.searchItem)
                  .then((result) => {
                    if (result && result.error) {
                      ErrorMessage.SetErrorMessage(result.error);
                    } else {
                      ErrorMessage.SetNotification('Exported to Excel.');
                    }
                  })
                  .catch(() => ErrorMessage.SetErrorMessage('EPST64'));
              },
              label: 'Export to Excel',
              tooltip: 'Export to Excel',
            },
          ]}
        />
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        <TabOfDataTable
          type={ClientInvoiceEvaluatorPaymentItem}
          serviceFunction={this.serviceFunction}
          convertDBItemsFunction={EvaluatorPaymentService.ConvertDBItemsForClientInvoice}
          searchParamsType={ClientInvoiceEvaluatorPaymentSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          orderBy='AsEvname'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in assignment apollo ID...'
          errorCode='EPST41'
        />
      </div>
    );
  }
}
